import * as React from 'react'

import { Button, Radio } from '@factorialco/deprecated-design-system'
import { AttendanceCustomPeriodEmployeeItemFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

import { type PayrollPeriodTypes } from 'modules/attendance/components/TimeTracking/Layout/form'
import { useCompensationCycle } from 'modules/attendance/hooks/useCompensationCycle'
import {
  getCompensationPeriodDescription,
  getCompensationPeriods,
} from 'modules/attendance/lib/compensationPeriodUtils'

export interface CustomCreateModalProps {
  onSubmit: () => void
  onCloseModal: () => void
  selected: AttendanceCustomPeriodEmployeeItemFragment[]
  selectedPayrollPeriod: PayrollPeriodTypes
  onPayrollPeriodChange: (period: PayrollPeriodTypes) => void
}

const CustomCreateModal = ({
  onSubmit,
  onCloseModal,
  selected,
  selectedPayrollPeriod,
  onPayrollPeriodChange,
}: CustomCreateModalProps) => {
  const { cycleRecurrence } = useCompensationCycle()
  const compensationPeriods = getCompensationPeriods(cycleRecurrence)

  const submitOrDisplayError = () => {
    onSubmit()
  }

  const onChangePayrollType = (value: PayrollPeriodTypes) => {
    onPayrollPeriodChange(value)
  }

  const handleRadioChange = (value: string) => {
    if (value === 'current' || value === 'next') {
      onChangePayrollType(value)
    }
  }

  return (
    <Modal
      title={i18n.t('time_tracking.modals.time_tracking_collection.bulk_compensation_create.title')}
      description={i18n.t(
        'time_tracking.modals.time_tracking_collection.bulk_compensation_create.description',
        {
          count: selected.length,
        }
      )}
      illustration="cash"
      onSubmit={submitOrDisplayError}
      onClose={onCloseModal}
      footer={
        <>
          <Button onClick={onCloseModal} type="secondary">
            {i18n.t('common.cancel')}
          </Button>
          <Button submit>
            {i18n.t(
              'time_tracking.modals.time_tracking_collection.bulk_compensation_create.submit'
            )}
          </Button>
        </>
      }
    >
      <Radio.Wrap>
        <Radio
          name={compensationPeriods.current.label}
          value={selectedPayrollPeriod}
          onChange={handleRadioChange}
          description={getCompensationPeriodDescription(true)}
          option={{
            label: compensationPeriods.current.label,
            value: 'current',
          }}
        />
      </Radio.Wrap>
      <Radio.Wrap>
        <Radio
          name={compensationPeriods.next.label}
          value={selectedPayrollPeriod}
          onChange={handleRadioChange}
          description={getCompensationPeriodDescription(false)}
          option={{
            label: compensationPeriods.next.label,
            value: 'next',
          }}
        />
      </Radio.Wrap>
    </Modal>
  )
}

export default observer(CustomCreateModal)
